import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.notes-reports-consolidated-page', () => {
  void import('./internal/notes-reports-consolidated-page')
    .then(({ default: Component }) => Component());
});
